import deburr from 'lodash/deburr';
export function generateSlugFromText(text) {
  if (!text) {
    return '';
  }
  return deburr(text).toLowerCase().replace(/\s/g, '-').replace(/[^a-zA-Z0-9-]/g, '-').trim().replace(/^[-]/, '').replace(/[-]$/, '');
}
//# sourceMappingURL=slugUtil.js.map
